module.exports = __webpack_public_path__ + "img/title3.ab39f99a.png";